import $ from 'jquery';

$('input[name="school[layout]"]').on('change', () => {
  const layout = $('input[name="school[layout]"]:checked').get(0).value;

  $('form.edit_school').attr('data-layout', layout);
});
